import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference4Error: string }>;

export const DispatchcustomerReference4Error: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference4Error",
        customerReference4Error: props.parameter.customerReference4Error,
    });
};

export const chain = [DispatchcustomerReference4Error];

const setCustomerReference4Error = createHandlerChainRunner(chain, "customerReference4Error");
export default setCustomerReference4Error;
